import { TimeBlockAbsenceModel } from '../../../core/models/timeblock/time-block.model';
import { AbsencePlannerEventModel } from '../../../core/models/absence-planner/absence-planner-event.model';
import { TimeBlockComponent } from '../../calendar/components/time-block/time-block.component';
import { ITimeBlockComponentItem } from '../../calendar/components/time-block/types/time-block-component-item-types';
import { TimeBlockContentType } from '../../calendar/components/time-block/types/time-block-types';

export class AbsencePlannerEventConverter {
  public static toPlannerEventModel(
    timeBlocks: ITimeBlockComponentItem[],
  ): AbsencePlannerEventModel[] {
    return timeBlocks.map((timeBlock) => {
      const plannerEventModel = new AbsencePlannerEventModel();
      const timeBlockAbsenceModel =
        timeBlock.timeBlockModel as TimeBlockAbsenceModel<TimeBlockComponent>;
      plannerEventModel.id = timeBlockAbsenceModel.id;
      plannerEventModel.start = timeBlockAbsenceModel.start;
      plannerEventModel.end = timeBlockAbsenceModel.end;
      plannerEventModel.userId = timeBlockAbsenceModel.userId;
      plannerEventModel.reason = timeBlockAbsenceModel.reason;
      plannerEventModel.fixInterval = timeBlockAbsenceModel.fixInterval;
      plannerEventModel.timeBlockViewType = timeBlockAbsenceModel.timeBlockViewType;

      return plannerEventModel;
    });
  }

  public static toITimeBlockComponentItem(
    plannerEventModel: AbsencePlannerEventModel,
  ): ITimeBlockComponentItem {
    const timeBlockAbsenceModel = new TimeBlockAbsenceModel<TimeBlockComponent>();
    timeBlockAbsenceModel.id = plannerEventModel.id;
    timeBlockAbsenceModel.start = plannerEventModel.start;
    timeBlockAbsenceModel.end = plannerEventModel.end;
    timeBlockAbsenceModel.userId = plannerEventModel.userId;
    timeBlockAbsenceModel.reason = plannerEventModel.reason;
    timeBlockAbsenceModel.fixInterval = plannerEventModel.fixInterval;
    timeBlockAbsenceModel.timeBlockViewType = plannerEventModel.timeBlockViewType;

    return {
      timeBlockModel: timeBlockAbsenceModel,
      id: plannerEventModel.id,
      timeBlockContentType: TimeBlockContentType.Absence,
      clone: () => null,
      insertIntoCalendar: () => {},
      removeFromCalendar: () => {},
    };
  }
}
